module.exports = __webpack_public_path__ + "assets/website-icon2.png?c02fd5535e81f38f675bbb31dd11f96b";